import PlatformTestScenarios from './PlatformTestScenarios'

/* eslint-disable camelcase, no-await-in-loop */
export default class PINOYPERYAHANTestScenarios extends PlatformTestScenarios {
  async bet_settleWin_adjustBet() {
    await this.setTestScenario(
      async () => {
        await this.requests.getBalance()
        await this.requests.bet()
        await this.requests.settleWin()
        await this.requests.getBalance({ action: 'settle' })
        await this.requests.adjustBet()
      },
    )
  }

  async bet_settleLose_adjustBet() {
    await this.setTestScenario(
      async () => {
        await this.requests.getBalance()
        await this.requests.bet()
        await this.requests.settleLose()
        await this.requests.getBalance({ action: 'settle' })
        await this.requests.adjustBet()
      },
    )
  }

  async bet_settleWin5Times_adjustBet() {
    await this.setTestScenario(
      async () => {
        await this.requests.getBalance()
        await this.requests.bet()

        const summaryBetReqId = this.requests.actions.summaryReqId

        for (let timesLoop = 0; timesLoop < 5; timesLoop += 1) {
          if (this.requests.actions.summaryReqId) this.requests.actions.summaryReqId = summaryBetReqId
          await this.requests.settleWin({ timesLoop })
        }
        await this.requests.getBalance({ action: 'settle' })

        await this.requests.adjustBet()
      },
    )
  }

  async bet_asyncSettleWin5Times_adjustBet() {
    await this.setTestScenario(
      async () => {
        await this.requests.getBalance()
        await this.requests.bet()

        if (this.requests.actions.summaryReqId) {
          this.requests.actions.summaryReqId += 1
          this.requests.actions.isAsync = true
        }

        await Promise.all(Array.from({ length: 5 }).map(async (_, timesLoop) => {
          await this.requests.settleWin({
            timesLoop,
            options: { isAsync: true },
          })
          return true
        }))
        await this.requests.getBalance({ action: 'asyncSettle' })

        await this.requests.adjustBet()
        delete this.requests.actions.isAsync
      },
    )
  }

  async bet_jackpotSettleWin_adjustBet() {
    await this.setTestScenario(
      async () => {
        await this.requests.getBalance()
        await this.requests.bet()
        await this.requests.settleWin({ options: { isJackpotWin: true } })
        await this.requests.getBalance({ action: 'settle' })
        await this.requests.adjustBet()
      },
    )
  }

  async bet_jackpotSettleWin_grandJackpotSettleWin_adjustBet() {
    await this.setTestScenario(
      async () => {
        await this.requests.getBalance()
        await this.requests.bet()

        await this.requests.settleWin({ options: { isJackpotWin: true, hasGrandJackpot: true } })
        await this.requests.getBalance({ action: 'settle' })

        await this.requests.settleWin({ options: { isJackpotWin: true, hasGrandJackpot: true } })
        await this.requests.getBalance({ action: 'settle' })

        await this.requests.adjustBet({ options: { hasGrandJackpot: true } })
      },
    )
  }

  async multiBets_bet1_bet2_settle2_jackpotSettleWin1_grandJackpotSettleWin1_adjustBet() {
    await this.setTestScenario(
      async () => {
        await this.requests.getBalance()

        const BET_LENGTH = 2
        const betIndexes = []
        for (let betIndex = 0; betIndex < BET_LENGTH; betIndex += 1) {
          await this.requests.bet({ betIndexes: [betIndex] })
          betIndexes.push(betIndex)
        }

        await this.requests.settleLose({ betIndexes: [1], options: { hasJackpotWin: true } })
        await this.requests.getBalance({ action: 'settle' })

        await this.requests.settleWin({ betIndexes: [0], options: { isJackpotWin: true, hasGrandJackpot: true } })
        await this.requests.getBalance({ action: 'settle' })

        await this.requests.settleWin({ betIndexes: [0], options: { isJackpotWin: true, hasGrandJackpot: true } })
        await this.requests.getBalance({ action: 'settle' })

        await this.requests.adjustBet({ options: { hasGrandJackpot: true } })
      },
    )
  }

  async multiBets_bet1_bet2_bet3_bet4_bet5_settle145_jackpotSettleWin23_adjustBet() {
    await this.setTestScenario(
      async () => {
        await this.requests.getBalance()

        const BET_LENGTH = 5
        const betIndexes = []
        for (let betIndex = 0; betIndex < BET_LENGTH; betIndex += 1) {
          await this.requests.bet({ betIndexes: [betIndex] })
          betIndexes.push(betIndex)
        }

        await this.requests.settle({
          betIndexes: [0, 3, 4],
          settleInfo: { winBetIndexes: [3] },
          options: { hasJackpotWin: true },
        })

        await this.requests.getBalance({ action: 'settle' })

        await this.requests.settleWin({ betIndexes: [1, 2], options: { isJackpotWin: true } })
        await this.requests.getBalance({ action: 'settle' })

        await this.requests.adjustBet()
      },
    )
  }
}
